export default __webpack_public_path__ + "static/logo-b1a9f5ee9846d2ed4ebb2171e0245058.png";